export interface PurchaseOrderReceiptStock {
  stockNo: string;
  batchNo: string;
  quantity: number;
  unit: string;
  price: number;
  value: number;
  currencySymbol: string;
}
